module.exports = __webpack_public_path__ + "static/img/5.a47261d3.png";